module.exports = __webpack_public_path__ + "static/assets/9591fa9bca0395fb2076dcb17918f6f2.png";